module.exports = __webpack_public_path__ + "img/faq3.4ffac6d1.png";